import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { BrowserRouter as Router, Route, NavLink, Switch } from 'react-router-dom'; // bring in a hook, and use a shorter alias, bring in another hook called switch
import HelloWorld  from '../articles/hello-world';
import Connect from '../articleComponents/connect';
import ArticleList from './articleList';
import { motion } from 'framer-motion';
import SocialMedia from '../articleComponents/SocialMedia';
import {Helmet} from "react-helmet";
import planet from '../pictures/planet_img.jpg';
import MetaTags from './MetaTags';
import ArticleListPublished from './articleList-tagPublished'

function ArticlesTagPublished() {
  return (
    <motion.div id="body"
initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Highway 60 Articles Page" desc="Highway 60 articles published in the general media: Israel National News, Times of Israel, Breslov World." 
URL="https://highway-60.web.app/articles-tag-published" imageURL={planet} />

<ul id="articleList">
    {/* to create links, we need to wrap every <li> item inside a <Link> tag. It takes one attribute, to="" which is the path to the page the nav text links to */}

<ArticleListPublished />
    </ul>
    <SocialMedia url="https://highway-60.web.app/articles-tag-published" title="Highway 60 Articles" hashtag="#marketing" hashtagArray={["writing", "marketing", "Israel"]} 
    via="TheHighway60" desc="Highway 60 articles published in the general media: Israel National News, Times of Israel, Breslov World." />    
    <Connect />
    </motion.div>  
  );
  }

export default ArticlesTagPublished;
